import { defineSlotRecipe } from '@chakra-ui/react';
import { checkboxSlotRecipe } from './Checkbox';
import { FontSizes, Radii, Space, TextStyles } from '../../types';

// RadioGroup's slots differ from checkbox's, so the shared checkbox base + variant styles
// are remapped onto the radio slots here.
const cbBase = checkboxSlotRecipe.base as Record<string, any>;
const cbVariant = ((checkboxSlotRecipe.variants as any)?.variant ?? {}) as Record<string, any>;

export const radioSlotRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'item', 'itemText', 'itemControl', 'itemAddon', 'indicator'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: Space.XS,
    },
    item: {
      ...cbBase.root,
      top: Space.SPACE_1,
    },
    itemText: {
      ...cbBase.label,
    },
    itemControl: {
      ...cbBase.control,
      borderRadius: Radii.FULL,
      boxSize: '1.125em',
    },
  },
  variants: {
    variant: {
      // Chakra's radioGroup defaults to variant `solid`, which beats `base` on this slot, so `solid` restates
      // Checkbox's checked fill; the built-in `.dot` (currentColor, white on the fill) is the centre dot.
      solid: {
        itemControl: {
          ...cbBase.control,
          borderRadius: Radii.FULL,
          boxSize: '1.125em',
          '& .dot': { scale: '0.5' },
        },
      },
      card: {
        item: cbVariant.card?.root,
        itemText: cbVariant.card?.label,
        itemControl: cbVariant.card?.control,
      },
      stacked: {
        item: cbVariant.stacked?.root,
        itemText: cbVariant.stacked?.label,
        itemControl: cbVariant.stacked?.control,
      },
    },
    size: {
      lg: {
        itemControl: { boxSize: 6 },
        itemText: {
          '& *:not(:where(.chakra-field__helperText))': { textStyle: TextStyles.UI_DEFAULT, fontWeight: 'normal' },
        },
      },
      md: {
        itemControl: { boxSize: 4, mt: 0.5 },
        itemText: {
          '& *:not(:where(.chakra-field__helperText))': { textStyle: TextStyles.UI_DEFAULT, fontWeight: 'normal' },
        },
      },
      sm: {
        itemControl: { boxSize: 4 },
        itemText: { fontSize: FontSizes.SM },
      },
      xs: {
        itemControl: { boxSize: 3.5 },
        itemText: { fontSize: FontSizes.XS },
      },
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'solid',
  },
});
